import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";

import { onChange_Createuser_Cohorts } from "../../../CreateUserComp/action";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CohortListComponent } from "./component";


const CohortListContainer = (props) => {
  const [data, setData] = useState([]);
  const [searchCohortData, setSearchCohortData] = useState(null);
  const [activeCohortType, setActiveCohortType] = useState("");
  const [loading, setLoading] = useState(false);

  const [offset, setOffset] = useState(0);
  const limit = 50;
  const [hasMore, setHasMore] = useState(true);
  const { userid } = useParams();

  // ✅ Fetch API
  const fetchCohorts = (reset = false, searchQuery = "", typeFilter = "", newOffset = offset) => {
    setLoading(true);

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts?limit=${limit}&offset=${newOffset}` +
        (searchQuery ? `&search_query=${searchQuery}` : "") +
        (typeFilter ? `&cohort_type_id=${typeFilter}` : ""),
      "GET",
      undefined,
      (response) => {
        setLoading(false);

        if (reset) {
          setData(response.list); // overwrite
        } else {
          setData((prev) => [...prev, ...response.list]); 
        }

        if (response.list.length < limit) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      },
      (err) => {
        setLoading(false);
        console.error("API error:", err);
        toastr.error("Failed", "Unable to fetch cohort listing");
      }
    );
  };

  // ✅ Initial fetch
  useEffect(() => {
    fetchCohorts(true, searchCohortData, activeCohortType, 0);
  }, []);

  // ✅ Scroll → load more
  const loadMore = () => {
    if (!loading && hasMore) {
      const newOffset = offset + limit;
      setOffset(newOffset);
      fetchCohorts(false, searchCohortData, activeCohortType, newOffset);
    }
  };

  // ✅ Search
  const searchCohort = (searchValue) => {
    setSearchCohortData(searchValue);
    setOffset(0);
    fetchCohorts(true, searchValue, activeCohortType, 0);
  };

  // ✅ Filter
  const handleCohortTypeClick = (id) => {
    setActiveCohortType(id);
    setOffset(0);
    fetchCohorts(true, searchCohortData, id, 0);
  };

  return (
    <CohortListComponent
      Search={searchCohort}
      filterCohortData={data}
      handleCohortTypeClick={handleCohortTypeClick}
      stagecohortsTypes={[
        { id: 1, name: "mobility" },
        { id: 2, name: "franchisee" },
        { id: 3, name: "df_access" },
        { id: 4, name: "QA" },
        { id: 5, name: "FOOD" },
        { id: 6, name: "service" },
        { id: 7, name: "city_payout" },
        { id: 8, name: "promos" },
        { id: 9, name: "combos" },
      ]}
      activeCohortType={activeCohortType}
      loading={loading}
      loadMore={loadMore}   // ✅ scroll callback
      hasMore={hasMore}     // ✅ stop scroll if no data
    />
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}
export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_Createuser_Cohorts,
})(CohortListContainer);
